import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { BeanConfiguracao } from 'src/bean/BeanConfiguracao';
import { BeanMonitoria } from 'src/bean/BeanMonitoria';
import { BeanStatusMonitory } from 'src/bean/BeanStatusMonitory';
import { StatusMonitoryService } from '../conteudo-global/status-monitory.service';
import { FeedbackLoginDialogService } from "./feedback-login-dialog.service";


import { AESEncryptDecryptService } from "../../../AESEncryptDecryptService";
import { ConfiguracaoService } from "../../configuracao/configuracao.service";
import { MonitoriaComponent } from "../monitoria.component";


@Component({
    selector: 'feedbackLoginDialog',
    templateUrl: 'feedback-login-dialog.html',
    styleUrls: ['../monitoria.component.css']
  })
  export class FeedbackLoginDialogDialog implements OnInit {

    hide = true;
    loading : boolean = false;
    public login:boolean = true;
    public senha:boolean = false;
    public aguarde:boolean = false;
    public idUser = this._AESEncryptDecryptService.decrypt(localStorage.getItem('idUser').trim());

    idStatusMonitoriaAdicionado : number = 0
    public beanMonitoria :  BeanMonitoria = new BeanMonitoria(null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null, [], [], null, [], [],null,null);

    public formLogin: FormGroup = new FormGroup({
      'usuario': new FormControl(this.data.userAvaliadoRe ? this.data.userAvaliadoRe : null, [Validators.required]),
      'senha': new FormControl(null, [Validators.required]),
      'feedback': new FormControl(null, [Validators.required])
    })

    constructor(
      public dialog: MatDialogRef<MonitoriaComponent>,
      private toastr: ToastrService,
      private statusMonitoryService : StatusMonitoryService,
      private configuracaoService : ConfiguracaoService,
      private router: Router,
      public feedbackService: FeedbackLoginDialogService,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private _AESEncryptDecryptService: AESEncryptDecryptService
    ) { }


    ngOnInit(): void {

    }

    public assinar(): void{

      if(this.formLogin.valid){

        const {feedback} = this.formLogin.value;
        const userAvaliadoId = this.data.userAvaliadoId;
        const userAvaliadoRe = this.data.userAvaliadoRe;
        const monitoryId = this.data.idMonitoria;
        const {senha} = this.formLogin.value;
        this.beanMonitoria.moniTxFeedback = feedback;
        this.beanMonitoria.moniDhFeedbackAvaliado = '1900-01-01T00:00:00';
        this.beanMonitoria.usuaIdCdUsuarioFeedback = this.data.lastRegularAppraiser;

        this.feedbackService.assinarFeedback(this.beanMonitoria, userAvaliadoId, userAvaliadoRe, senha, monitoryId).subscribe((retorno:BeanMonitoria)=>{
          this.toastr.success('Feedback assinado com sucesso', 'SUCESSO');

          this.beanMonitoria.moniDhFeedbackAvaliado = retorno.moniDhFeedbackAvaliado;
          this.beanMonitoria.usuaIdCdUsuarioFeedback = retorno.usuaIdCdUsuarioFeedback;

          this.closeDialog();
          
          //ALTERADO PARA ADICIONAR STATUS DE ENCERRAMENTO DA MONITORIA VIA BACKEND  updateMonitoria
          /*
          this.configuracaoService.getConfiguracaoByChave("grupoconfig.status.assinarfeedback").then((retorno:BeanConfiguracao)=>{

                  let beanStatusMonitoryInicial : BeanStatusMonitory = new BeanStatusMonitory();

                    beanStatusMonitoryInicial.statIdCdStatus = retorno.confDsValString
                    beanStatusMonitoryInicial.moniIdCdMonitoria = monitoryId;
                    beanStatusMonitoryInicial.usuaIdCdUsuario = this.idUser;

                    //GERAR O STATUS
                    this.statusMonitoryService.addStatusMonitory(beanStatusMonitoryInicial, 0).then((retorno:BeanStatusMonitory)=>{

                      this.idStatusMonitoriaAdicionado = Number(beanStatusMonitoryInicial.statIdCdStatus)

                      this.closeDialog();

                    }, errorresponse => {
                    }).catch((retorno:any) => {
                      if(retorno.error.error_description.indexOf("Access token expired")>-1){
                          alert("Sessão Expirada");
                          this.router.navigate(['']);
                        }
                    });
                


          }, errorresponse => {
                this.toastr.error('Erro conexao backend\nContate o suporte.','COMBO GESTOR');

          }).catch((retorno:any) => {

              if(retorno.error.error_description.indexOf("Access token expired")>-1){
                  alert("Sessão Expirada");
                  this.router.navigate(['']);
                }

          });

          */














        },
        errorResponse => {
          this.toastr.error(errorResponse.error.message, 'ERRO');
        });

      }

    }

    closeDialog() {
      let data = {
        moniTxFeedbackAssinado: this.beanMonitoria.moniTxFeedback,
        moniDhFeedbackAvaliado: this.beanMonitoria.moniDhFeedbackAvaliado,
        usuaIdCdUsuarioFeedback: this.beanMonitoria.usuaIdCdUsuarioFeedback
      };
      this.dialog.close(data);
    }


  }
